import Box from "@mui/material/Box";

import { EditButton } from "./EditButton";
import RemoveButton from "./RemoveButton";

export const getColumns = (t) => {
	return [
		{ label: t("ordinal_number_short"), name: "lp" },
		{ label: t("company_name_label"), name: "name" },
		{
			label: t("contact_person"),
			name: "firstName",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const firstName = value || "";
					const lastName = tableMeta.rowData[8] || "";

					if (firstName || lastName) {
						return firstName + " " + lastName;
					}

					return null;
				},
			},
		},
		{ label: t("nip_label"), name: "nip" },
		{ label: t("email_address_to_send"), name: "email" },
		{
			label: t("phone_label"),
			name: "phone",
		},
		{
			label: t("actions"),
			name: "id",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRender: (value, tableMeta, updateValue) => {
					const groupId = tableMeta.rowData[7];

					const name = tableMeta.rowData[1] || "";
					const firstName = tableMeta.rowData[2] || "";
					const nip = tableMeta.rowData[3] || "";
					const email = tableMeta.rowData[4] || "";
					const phone = tableMeta.rowData[5] || "";
					const lastName = tableMeta.rowData[8] || "";

					return (
						<Box sx={{ display: "flex", gap: "6px", justifyContent: "center" }}>
							<RemoveButton groupId={groupId} recipientId={value} />
							<EditButton
								groupId={groupId}
								recipientId={value}
								recipient={{
									name,
									firstName,
									lastName,
									email,
									phone,
									nip,
								}}
							/>
						</Box>
					);
				},
			},
		},
		// 7
		{ label: "GRUPA", name: "groupId", options: { display: false } },
		{ label: "lastName", name: "lastName", options: { display: false } },
	];
};

export const getOptions = (t) => {
	return {
		searchOpen: true,
		search: false,
		searchAlwaysOpen: true,
		searchPlaceholder: t("search"),
		filter: false,
		download: true,
		viewColumns: false,
		selectableRows: "none",
		print: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		rowsPerPage: 20,
		textLabels: {
			pagination: {
				next: t("next_page"),
				previous: t("previous_page"),
				rowsPerPage: t("rows_per_page"),
				displayRows: t("of"),
			},
			toolbar: {
				search: t("search"),
				downloadCsv: t("download_csv"),
				print: t("print"),
				viewColumns: t("select_columns"),
				filterTable: t("filters"),
			},
			filter: {
				title: t("filters"),
				reset: t("reset"),
				all: t("all"),
			},
			viewColumns: {
				title: t("show_columns"),
			},
			selectedRows: {
				text: t("removed_rows"),
				delete: t("remove"),
			},
			body: {
				noMatch: t("no_matching_data_found"),
			},
		},
	};
};
